export default __webpack_public_path__ + "static/media/logo.d34d2f4d.png";